import createAxiosInstance from './axiosConfig';
import { OriginadorDTO } from '../shared/dto/originadorDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/empregadorOriginadorController');

export default class FinanciamentoOriginadorService {
    axios: any;

    constructor() {
        this.axios = axiosInstance;
    }

    async incluirAlterarEmpregadorOriginador(id: number | string, lista: any[]) {
        return await this.axios.post(
            '/incluirAlterarEmpregadorOriginador',
            lista,
            {
                params: {
                    idReferencia: id
                }
            }
        );
    }

    async listarEmpregadorOriginador(idEmpregador: number | string) {
        return await this.axios.get(`/listarEmpregadorOriginador?idEmpregador=${idEmpregador}`);
    }

}